var _rect, _path, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 3.6C15.5 3.54477 15.4552 3.5 15.4 3.5H6.6C6.54477 3.5 6.5 3.54477 6.5 3.6V7.775C6.5 7.83023 6.54477 7.875 6.6 7.875H7.68571C7.74094 7.875 7.78571 7.91977 7.78571 7.975V11.5676C7.78571 11.6031 7.80461 11.636 7.83533 11.6539L10.9496 13.4706C10.9807 13.4888 11.0193 13.4888 11.0504 13.4706L14.1647 11.6539C14.1954 11.636 14.2143 11.6031 14.2143 11.5676V7.975C14.2143 7.91977 14.2591 7.875 14.3143 7.875H15.4C15.4552 7.875 15.5 7.83023 15.5 7.775V3.6Z",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5V16.5C11 17.5 10.4 19.5 8 19.5C5.6 19.5 3.33333 19.5 2.5 19.5",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 5,
    x2: 2.5,
    y2: 5,
    stroke: "#333333",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 5,
    x2: 15.5,
    y2: 5,
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinting);
export default __webpack_public_path__ + "static/media/printing.10ef58183dea8cba35275db60e98bbac.svg";
export { ForwardRef as ReactComponent };